"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireDefault(require("react"));
var _APIProducerCard = require("./APIProducerCard");
var _image_kite = _interopRequireDefault(require("@svb/svbbranding/dist/assets/images/image_kite.svg"));
var _image_ProducerJourney = _interopRequireDefault(require("@svb/svbbranding/dist/assets/images/image_ProducerJourney.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Global components
 * By Bhargav Shivaprasad <bshivaprasad@svb.com> (www.svb.com)
 * Summary
 * This component renders an SVB API Producer Header
 */

/**
 * 
 * @param title - title for the header.
 * @param slogan - slogan title for the header
 * @param description - description for the header
 * @param cardsData - individual cards data - title, description, color(primary400, primary300, green and blue) 
 * @param image - image for the title component
 * @param icons - list of icons image
 * @returns API Consumer Card
 */
const SVBApiProducerHeader = props => {
  var _props$title, _props$slogan, _props$description, _props$cardsData, _props$image, _props$icons;
  const title = (_props$title = props === null || props === void 0 ? void 0 : props.title) !== null && _props$title !== void 0 ? _props$title : "";
  const slogan = (_props$slogan = props === null || props === void 0 ? void 0 : props.slogan) !== null && _props$slogan !== void 0 ? _props$slogan : "";
  const description = (_props$description = props === null || props === void 0 ? void 0 : props.description) !== null && _props$description !== void 0 ? _props$description : "";
  const cardsData = (_props$cardsData = props === null || props === void 0 ? void 0 : props.cardsData) !== null && _props$cardsData !== void 0 ? _props$cardsData : [];
  const image = (_props$image = props === null || props === void 0 ? void 0 : props.image) !== null && _props$image !== void 0 ? _props$image : _image_kite.default;
  const icons = (_props$icons = props === null || props === void 0 ? void 0 : props.icons) !== null && _props$icons !== void 0 ? _props$icons : _image_ProducerJourney.default;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-6 col-md-3"
  }, /*#__PURE__*/_react.default.createElement("h1", {
    className: "heading-xxlarge ph-slogan-color"
  }, slogan), /*#__PURE__*/_react.default.createElement("h1", {
    className: "heading-xxlarge"
  }, title), /*#__PURE__*/_react.default.createElement("p", {
    className: "sub-heading-medium"
  }, description), /*#__PURE__*/_react.default.createElement("img", {
    src: image
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-12 col-md-8"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row gy-1 g-3"
  }, (cardsData === null || cardsData === void 0 ? void 0 : cardsData.length) > 0 && (cardsData === null || cardsData === void 0 ? void 0 : cardsData.map(item => {
    return /*#__PURE__*/_react.default.createElement(_APIProducerCard.APIProducerCard, {
      title: item === null || item === void 0 ? void 0 : item.title,
      description: item === null || item === void 0 ? void 0 : item.description,
      color: item === null || item === void 0 ? void 0 : item.color
    });
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col pt-4"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: icons
  })));
};
var _default = SVBApiProducerHeader;
exports.default = _default;